import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedState from 'pinia-plugin-persistedstate'
import { IonicVue } from '@ionic/vue'
import { installI18n } from '@/plugins/i18n'
import { addIcons } from 'ionicons'
import { 
  accessibility, 
  eye, 
  eyeOff,
  informationCircle, 
  alertCircle,
  home,
  location,
  compass,
  people,
  person,
  settings,
  helpCircle,
  document,
  shield,
  notifications,
  map,
  chevronBack,
  chevronForward,
  walk,
  settingsOutline,
  mapOutline,
  search,
  star,
  starOutline,
  accessibilityOutline,
  helpCircleOutline,
  logOutOutline,
  timeOutline,
  bulb,
  time,
  statsChart,
  pin,
  camera,
  add,
  close,
  checkmark,
  warning,
  arrowBack,
  ellipsisVertical,
  checkmarkCircle,
  navigate,
  share,
  logoGoogle,
  logoInstagram,
  logoWhatsapp,
  logoYoutube,
  chatbubbles,
  create,
  flag,
  trash,
  restaurant,
  business,
  medical,
  school,
  storefront,
  leaf,
  card,
  // Add missing icons
  sunnyOutline,
  moonOutline,
  locationOutline,
  play,
  refresh,
  navigateOutline,
  speedometerOutline,
  stop,
  peopleOutline,
  addCircle,
  informationCircleOutline,
  handLeftOutline,
  personOutline,
  notificationsOutline,
  languageOutline,
  resizeOutline,
  analyticsOutline,
  cloudOfflineOutline,
  folderOutline,
  warningOutline,
  shieldCheckmarkOutline,
  documentTextOutline,
  bugOutline,
  mailOutline,
  downloadOutline,
  globeOutline,
  libraryOutline,
  listOutline,
  copyOutline,
  codeOutline,
  buildOutline,
  calendarOutline,
  phonePortraitOutline,
  hardwareChipOutline,
  laptopOutline,
  walkOutline,
  fitnessOutline,
  // stairsOutline, // Not available in Ionicons
  // trailSignOutline, // Not available in Ionicons
  carOutline,
  trendingUpOutline,
  trendingDownOutline,
  umbrellaOutline,
  eyeOutline,
  earOutline,
  volumeHighOutline,
  contrastOutline,
  businessOutline,
  medicalOutline,
  carSportOutline,
  trainOutline,
  flaskOutline,
  imagesOutline,
  trashOutline,
  cloud,
  cloudOutline,
  cloudOffline,
  wifiOutline,
  cloudDownloadOutline,
  sync,
  syncOutline,
  refreshOutline,
  refreshCircleOutline,
  pauseOutline,
  compassOutline,
  shieldOutline,
  shareOutline,
  bulbOutline,
  hourglassOutline,
  sendOutline,
  filterOutline,
  walkOutline as footstepsOutline, // Using walkOutline as fallback for footsteps
  ellipsisHorizontal,
  ellipseOutline,
  bicycle,
  bicycleOutline,
  flagOutline,
  gitCompareOutline,
  statsChartOutline,
  expandOutline,
  linkOutline,
  documentOutline,
  gridOutline,
  flashOutline,
  cameraOutline,
  lockClosedOutline,
  closeCircle
} from 'ionicons/icons'
import router from './router'
import App from './App.vue'
import { i18n } from './plugins/i18n'
import { installSentry, captureException } from './plugins/sentry'

// Import Ionic CSS
import '@ionic/vue/css/core.css'
import '@ionic/vue/css/normalize.css'
import '@ionic/vue/css/structure.css'
import '@ionic/vue/css/typography.css'
import '@ionic/vue/css/ionic.bundle.css'

// Import custom styles
import './theme/brand-variables.css'
import './theme/variables.css'
import './theme/global.css'


// Register Ionicons
addIcons({
  accessibility,
  eye,
  'eye-off': eyeOff,
  'information-circle': informationCircle,
  'alert-circle': alertCircle,
  home,
  location,
  compass,
  people,
  person,
  settings,
  'help-circle': helpCircle,
  document,
  shield,
  notifications,
  map,
  'chevron-back': chevronBack,
  'chevron-forward': chevronForward,
  walk,
  'settings-outline': settingsOutline,
  'map-outline': mapOutline,
  search,
  star,
  'star-outline': starOutline,
  'accessibility-outline': accessibilityOutline,
  'help-circle-outline': helpCircleOutline,
  'log-out-outline': logOutOutline,
  'time-outline': timeOutline,
  bulb,
  time,
  'stats-chart': statsChart,
  pin,
  camera,
  add,
  close,
  checkmark,
  warning,
  'arrow-back': arrowBack,
  'ellipsis-vertical': ellipsisVertical,
  'checkmark-circle': checkmarkCircle,
  'close-circle': closeCircle,
  'ellipse-outline': ellipseOutline,
  navigate,
  share,
  'logo-google': logoGoogle,
  'logo-instagram': logoInstagram,
  'logo-whatsapp': logoWhatsapp,
  'logo-youtube': logoYoutube,
  chatbubbles,
  create,
  flag,
  trash,
  restaurant,
  business,
  medical,
  school,
  storefront,
  leaf,
  card,
  sunnyOutline,
  moonOutline,
  locationOutline,
  play,
  refresh,
  'navigate-outline': navigateOutline,
  'speedometer-outline': speedometerOutline,
  stop,
  'people-outline': peopleOutline,
  'add-circle': addCircle,
  'information-circle-outline': informationCircleOutline,
  'hand-left': handLeftOutline,
  'person-outline': personOutline,
  'notifications-outline': notificationsOutline,
  'language-outline': languageOutline,
  'resize-outline': resizeOutline,
  'analytics-outline': analyticsOutline,
  'cloud-offline-outline': cloudOfflineOutline,
  'folder-outline': folderOutline,
  'warning-outline': warningOutline,
  'shield-checkmark-outline': shieldCheckmarkOutline,
  'document-text-outline': documentTextOutline,
  'bug-outline': bugOutline,
  'mail-outline': mailOutline,
  'download-outline': downloadOutline,
  'globe-outline': globeOutline,
  'library-outline': libraryOutline,
  'list-outline': listOutline,
  'copy-outline': copyOutline,
  'code-outline': codeOutline,
  'build-outline': buildOutline,
  'calendar-outline': calendarOutline,
  'phone-portrait-outline': phonePortraitOutline,
  'hardware-chip-outline': hardwareChipOutline,
  'laptop-outline': laptopOutline,
  'walk-outline': walkOutline,
  'fitness-outline': fitnessOutline,
  'stairs-outline': trendingDownOutline, // Using trending-down as fallback for stairs
  'trail-sign-outline': resizeOutline, // Already registered above
  'car-outline': carOutline,
  'trending-up-outline': trendingUpOutline,
  'trending-down-outline': trendingDownOutline,
  'umbrella-outline': umbrellaOutline,
  'eye-outline': eyeOutline,
  'ear-outline': earOutline,
  'volume-high-outline': volumeHighOutline,
  'contrast-outline': contrastOutline,
  'business-outline': businessOutline,
  'medical-outline': medicalOutline,
  'car-sport-outline': carSportOutline,
  'train-outline': trainOutline,
  'flask-outline': flaskOutline,
  'images-outline': imagesOutline,
  'trash-outline': trashOutline,
  cloud,
  'cloud-outline': cloudOutline,
  'cloud-offline': cloudOffline,
  'wifi-outline': wifiOutline,
  'cloud-download-outline': cloudDownloadOutline,
  sync,
  'sync-outline': syncOutline,
  'refresh-outline': refreshOutline,
  'refresh-circle-outline': refreshCircleOutline,
  'pause-outline': pauseOutline,
  'compass-outline': compassOutline,
  'shield-outline': shieldOutline,
  'share-outline': shareOutline,
  'bulb-outline': bulbOutline,
  'hourglass-outline': hourglassOutline,
  'send-outline': sendOutline,
  'filter-outline': filterOutline,
  'footsteps-outline': footstepsOutline,
  'ellipsis-horizontal': ellipsisHorizontal,
  bicycle,
  'bicycle-outline': bicycleOutline,
  'flag-outline': flagOutline,
  'git-compare-outline': gitCompareOutline,
  'stats-chart-outline': statsChartOutline,
  'expand-outline': expandOutline,
  'link-outline': linkOutline,
  'document-outline': documentOutline,
  'grid-outline': gridOutline,
  'flash-outline': flashOutline,
  'camera-outline': cameraOutline,
  'lock-closed-outline': lockClosedOutline
})

// Initialize Pinia store
const pinia = createPinia()
pinia.use(piniaPluginPersistedState)

const app = createApp(App)
  .use(IonicVue, {
    rippleEffect: false,
    mode: 'ios' // Use iOS mode for consistent design across platforms
  })
  .use(pinia)
  .use(i18n) // Install i18n directly (before App component setup runs)
  .use(router)

// Initialize Sentry before mount so Vue errorHandler is in place for first paint.
// No-ops when VITE_SENTRY_DSN is unset.
installSentry(app, router)

router.isReady().then(() => {
  app.mount('#app')
})

// Import PWA Elements for Capacitor plugins (Camera, etc.)
import { defineCustomElements } from '@ionic/pwa-elements/loader'
defineCustomElements(window)

// Global unhandled promise rejection handler — forwards to Sentry instead of swallowing.
window.addEventListener('unhandledrejection', (event) => {
  if (import.meta.env.DEV) {
    console.warn('[Unhandled Promise Rejection]', event.reason)
  }
  captureException(event.reason, { source: 'unhandledrejection' })
  event.preventDefault()
})